import {Companies} from "./models.js";

function CompanyAlert() {

    // Strings
    const name = null;
    const description = null;
    const type = null;

    // Boolean
    const shown = false;

    // Foreign keys
    const companyId = null;

    return {
        name,
        description,
        type,
        shown,
        companyId,
    };
}

function getCompanyAlertCompany(companyAlert) {
    return Companies.find({'$loki': companyAlert.$loki})[0];
}


export { CompanyAlert, getCompanyAlertCompany }
